import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Field = styled.div`
  margin-left: 10px;
`

export const selectStyle = {
  container: provided => ({
    ...provided,
    minWidth: '240px'
  })
}
